import React, { useEffect, useState } from "react";
import "./css/FAQ.css"; // Dedicated styling file

// Import your standard page shell components
import Navbar from "./components/Navbar";
import Newsletter from "./components/NewsLetter";
import Footer from "./components/Footer";
import { FaChevronDown, FaQuestionCircle, FaHeadset } from "react-icons/fa";

function FAQ() {
    // Automatically scroll to top when visiting the FAQ page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // State to track open/closed accordion items (allows multiple or single toggle)
    const [activeIndex, setActiveIndex] = useState(0); // Default first item open

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    // Comprehensive FAQ list tailored for Crestest Learning Ventures LLP
    const faqData = [
        {
            question: "What is Crestest Learning Ventures LLP (CLV)?",
            answer: "Crestest Learning Ventures LLP is an innovative online education platform based in India, dedicated to providing progressive, high-quality learning experiences and academic support for school-level students."
        },
        {
            question: "How do I create an account or register for courses?",
            answer: "You can easily sign up by downloading our mobile application or visiting our official website at www.crestest.com. Click on the registration or sign-up button, enter your details (such as name, email, phone number, and educational interests), and set up your secure credentials."
        },
        {
            question: "What system requirements are needed to access the platform?",
            answer: "Our eLearning platform is accessible via most modern web browsers on desktops and laptops, as well as through our dedicated mobile application on Android and iOS devices. A stable internet connection is recommended for seamless video streaming and live classes."
        },
        {
            question: "How can I track my ward's learning progress and performance?",
            answer: "Once logged into your registered user profile, you can view comprehensive dashboard analytics, test results, participation records, and feedback reports detailing your ward's learning patterns and development milestones."
        },
        {
            question: "Are my personal and payment details secure?",
            answer: "Yes, absolutely. We adhere to strict ethical standards and employ robust physical, electronic, and procedural safeguards in compliance with Indian Data Protection Rules to secure your information. All online payment transactions are processed through trusted, secure gateway partners."
        },
        {
            question: "Can I withdraw my consent or delete my account data?",
            answer: "Yes, you have the option at any time to withdraw your consent for data processing by sending a written request to our support team. Please note that withdrawing consent may limit or restrict your continued access to certain platform services and features."
        },
        {
            question: "How do I reach out to customer support or the Grievance Officer?",
            answer: "If you have any queries, technical issues, or grievances regarding our services or privacy policies, you can reach out directly to our Grievance Officer via email at support@crestest.com."
        }
    ];

    return (
        
        <div className="page-wrapper">{/* Site Navigation Bar */}
                        <Navbar />
            {/* Main Content Area */}
            <div className="faq-page">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        
                        
                        <div className="col-lg-10">
                            {/* Page Header */}
                            <div className="faq-header text-center mb-5">
                                <div className="faq-icon-wrapper mb-3">
                                    <FaQuestionCircle className="faq-main-icon" />
                                </div>
                                <h1 className="faq-title">Frequently Asked Questions</h1>
                                <p className="faq-subtitle">
                                    Crestest Learning Ventures LLP — Everything you need to know
                                </p>
                            </div>

                            {/* FAQ Content Card / Accordion Container */}
                            <div className="faq-card p-4 p-md-5 shadow-sm">
                                <p className="lead-text mb-4">
                                    Find answers to common questions regarding our online educational platform, courses, account management, privacy, and technical support. If you can't find what you are looking for, feel free to contact us.
                                </p>

                                <div className="accordion-list">
                                    {faqData.map((item, index) => {
                                        const isOpen = activeIndex === index;
                                        return (
                                            <div 
                                                key={index} 
                                                className={`faq-accordion-item ${isOpen ? "active" : ""}`}
                                            >
                                                <button
                                                    className="faq-question-btn"
                                                    onClick={() => toggleAccordion(index)}
                                                    aria-expanded={isOpen}
                                                >
                                                    <span className="faq-q-number">0{index + 1}.</span>
                                                    <span className="faq-q-text">{item.question}</span>
                                                    <FaChevronDown className={`faq-chevron ${isOpen ? "rotate" : ""}`} />
                                                </button>
                                                
                                                <div className={`faq-answer-collapse ${isOpen ? "show" : ""}`}>
                                                    <div className="faq-answer-body">
                                                        <p>{item.answer}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <hr className="section-divider my-5" />

                                {/* Help Box Banner inside FAQ */}
                                <div className="faq-help-box text-center p-4">
                                    <FaHeadset className="faq-help-icon mb-2" />
                                    <h4>Still have questions?</h4>
                                    <p>We are always here to help you out with any doubts or inquiries.</p>
                                    <a href="mailto:support@crestest.com" className="faq-support-btn">
                                        Contact Support
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Global Newsletter Section */}
            <Newsletter />

            {/* Global Footer Component */}
            <Footer />
        </div>
    );
}

export default FAQ;